import React from 'react';
import EditComponent from './editComponent';
import { ALTERATION_API } from '../constants';


// const ALTERATION_API = `http://qa.rm.qualitapps.com/api/alteration`;
// const ALTERATION_API = `http://rmapi.geseme.com/api/alteration`;
// const ALTERATION_API = `http://192.168.88.15:8080/api/alteration`;
// const ALTERATION_API = `http://dev.api.rmagile.qualitapps.com/api/alteration`;

class Alteration extends React.Component {
    constructor(props) {
        super(props);
        this.backToParent = this.backToParent.bind(this);
        this.reload_app = this.reload_app.bind(this);
    }

    state = {
        alterations : [],
        components: [],
        subComponents: [],
        loadPopup: false,
        selectedAlteration: {},
        alterationLoad: true,
        selectedAlterationId: ''
    }

    componentDidMount() {
       this.getAlterations()
    }
    
    getAlterations = async () => {
        const token = localStorage.getItem('token');
            await fetch(ALTERATION_API, {
                method: "GET" ,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(async res => await res.json())
            .then(async res => {
                let alterationArray = await res.data;
                await this.setState({
                    alterations: alterationArray,
                    alterationLoad: false
                });
            })
            .catch(e =>console.log('error'))
    }

    getComponents = async (e) => {
        e.preventDefault();
        let allComponents = [];
        this.setState({
            components: allComponents
        })
    }

    printComponentName = async (name) => {
        const api = await fetch(ALTERATION_API+"/"+name);
        const apiData = await api.json();
        let alterationArray = apiData.data;
        this.setState({
            subComponents : alterationArray
        })
    }

    loadEditPopup = async () => {

        this.setState({
            loadPopup: true
        })
    }

    selectedComponent = async (alteration) => {
        this.setState({
            selectedAlteration: this.state.alterations,
            selectedAlterationId: alteration
        })
    }

    backToParent() {
        this.setState({
            loadPopup: false
        })
    }

    reload_app(obj){
        this.setState({
            alterations: obj
        })
    }

    render() {

        const editPopup = ( this.state.loadPopup &&
                <EditComponent 
                selectedAlteration = {this.state.selectedAlteration}
                selectedAlterationId = {this.state.selectedAlterationId}
                backToParent = {this.backToParent}
                reload_app={this.reload_app.bind()}
                preloader={this.state.alterationLoad}
                />
            

        ) 
        return (
            <div className={'row'}>
                {editPopup}
                { !this.state.loadPopup &&
                    this.state.alterations.map((alterationTop, topIteration) => {
                        return(
                            <div className={'col-xs-6'}>
                            <div key = {topIteration} className={'well'}>
                            <div className={'scroll'}>
                                <h3>{alterationTop.component.name} - {alterationTop.component.id}</h3>
                                <button onClick={ (e) => {this.loadEditPopup(); this.selectedComponent(alterationTop.component.id);}} className={'btn btn-primary edit-button'}>Editar</button>
                                {                            
                                     alterationTop.sub_components.map((subComponentArray, subComponentIteration) => {
                                        return (
                                            
                                            <div key = {subComponentIteration} className={'col-xs-6 p-0'}>
                                                <h4>{subComponentArray.name} - {subComponentArray.id}</h4>
                                                {
                                                    subComponentArray.alterations.map((bottomIterationArray, bottomIteration) => {
                                                        return (
                                                            <div key = {bottomIteration}>
                                                               <p> {bottomIterationArray.name}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            
                                        )
                                     })
                                     
                                }

                                </div>
                            </div>
                            </div>
                        )
                    })
                }
            </div>
        );     
    }
};

export default Alteration;



// WEBPACK FOOTER //
// ./src/components/Alterations.js